(function () {
  "use strict";

  // Insole finder: scroll to our own quiz on the home page (replaces Pickzen)
  function goToQuiz(e) {
    if (e) e.preventDefault();
    var quiz = document.getElementById("find-your-kidsole");
    if (quiz) {
      quiz.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = "/#find-your-kidsole";
    }
  }

  $("#insole-finder-btn").click(goToQuiz);

  $(".sf-nav li").last().click(goToQuiz);

  //carousel daily deal section on home page
  var mySwiper = new Swiper(".dailydeal-swiper", {
    speed: 400,
    spaceBetween: 30,
    loop: true,
    // delay between transitions in ms
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 3,
    grabCursor: true,
    breakpoints: {
      425: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  // Sizing guide magnific popup
  $(".kidsole-size-guide").on("click", function (event) {
    event.preventDefault();
    var gallery = $(this).attr("href");
    $(gallery)
      .magnificPopup({
        delegate: "a",
        type: "image",

        image: {
          verticalFit: true,
          titleSrc: function (item) {
            return '<a href="https://cdn.shopify.com/s/files/1/0668/0320/4322/files/Kids-Fitting_Size-Guide.pdf" id="kidsolePrintImage">Download and print our size guide here</a>';
          },
        },
      })
      .magnificPopup("open");
  });
  
  // Clinicians page top left button scroll to target div
  // $(".clinicians-top-buttons .left-button").click(function () {
  //   $("html, body").animate(
  //     {
  //       scrollTop: $(".clinicians__form-left").offset().top,
  //     },
  //     2000
  //   );
  // });



  
})(jQuery);
